__turbopack_context__.v({
  "axisFooter": "overview-progress-chart-module-scss-module__BIUvGG__axisFooter",
  "axisFooterLeft": "overview-progress-chart-module-scss-module__BIUvGG__axisFooterLeft",
  "axisFooterMonth": "overview-progress-chart-module-scss-module__BIUvGG__axisFooterMonth",
  "axisFooterRight": "overview-progress-chart-module-scss-module__BIUvGG__axisFooterRight",
  "chartHost": "overview-progress-chart-module-scss-module__BIUvGG__chartHost",
  "chartPlot": "overview-progress-chart-module-scss-module__BIUvGG__chartPlot",
  "chartSvg": "overview-progress-chart-module-scss-module__BIUvGG__chartSvg",
  "dayLabel": "overview-progress-chart-module-scss-module__BIUvGG__dayLabel",
  "dayLabelSelected": "overview-progress-chart-module-scss-module__BIUvGG__dayLabelSelected",
  "dayLabelsGroup": "overview-progress-chart-module-scss-module__BIUvGG__dayLabelsGroup",
  "hourLabel": "overview-progress-chart-module-scss-module__BIUvGG__hourLabel",
  "hourLabelSelected": "overview-progress-chart-module-scss-module__BIUvGG__hourLabelSelected",
  "inspectionTooltip": "overview-progress-chart-module-scss-module__BIUvGG__inspectionTooltip",
  "referenceLineAirtime": "overview-progress-chart-module-scss-module__BIUvGG__referenceLineAirtime",
  "referenceLineShare": "overview-progress-chart-module-scss-module__BIUvGG__referenceLineShare",
  "yAxisLineLeft": "overview-progress-chart-module-scss-module__BIUvGG__yAxisLineLeft",
  "yAxisLineRight": "overview-progress-chart-module-scss-module__BIUvGG__yAxisLineRight",
  "yAxisTargetLabel": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTargetLabel",
  "yAxisTargetLabelRight": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTargetLabelRight",
  "yAxisTickLeft": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTickLeft",
  "yAxisTickReference": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTickReference",
  "yAxisTickRight": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTickRight",
  "yAxisTickRightReference": "overview-progress-chart-module-scss-module__BIUvGG__yAxisTickRightReference",
});
